for ( const node of document.querySelectorAll( '.event-actions' ) ) {
	const calendar = node.querySelector( '.event-actions__add-to-calendar' );
	const dialog = node.querySelector( '.event-actions__dialog' );

	if ( calendar && dialog ) {
		calendar.addEventListener( 'click', (e) => {
			e.preventDefault();
			dialog.showModal();
		} );

		dialog.addEventListener( 'click', (e) => {
			if ( e.target === dialog ) {
				dialog.close();
			}
		}, true );
	}
}
